if ($('.votes').length) {
    $('.votes .rate-list').each(function () {
        var number = parseInt($.trim($(this).find('.rate-value').text()), 10);
        var starsOn = Math.max(0, Math.min(5, isNaN(number) ? 0 : number));
        var starsOff = 5 - starsOn;

        var $starsWrap = $(this).find('.rate-star.stars');
        $starsWrap.empty();

        for (var i = 0; i < starsOn; i++) {
            $starsWrap.append('<span class="star star-on"></span>');
        }

        for (var j = 0; j < starsOff; j++) {
            $starsWrap.append('<span class="star star-off"></span>');
        }
    });
}
